/// MessageEnvelope schema for worker communication (COMM-01).
/// encode/decode with @msgpack/msgpack for C++ <-> JS round-trip.
// Canonical type definition: app/ui/src/protocol/types.ts

import { encode, decode } from "@msgpack/msgpack";

export interface MessageEnvelope {
  type: string;
  correlation_id?: string;
  payload: Record<string, unknown>;
  direction: "cmd" | "evt";
}

export function encodeEnvelope(envelope: MessageEnvelope): Uint8Array {
  const obj = {
    type: envelope.type,
    correlation_id: envelope.correlation_id ?? "",
    payload: envelope.payload ?? {},
    direction: envelope.direction,
  };
  return encode(obj);
}

export function decodeEnvelope(buffer: ArrayBuffer | Uint8Array): MessageEnvelope {
  const decoded = decode(buffer) as Record<string, unknown>;
  return {
    type: String(decoded.type ?? ""),
    correlation_id: decoded.correlation_id ? String(decoded.correlation_id) : undefined,
    payload: (decoded.payload as Record<string, unknown>) ?? {},
    direction: (decoded.direction as "cmd" | "evt") ?? "cmd",
  };
}
